// Campus photo for /colleges/university-of-southern-california: CC BY-SA 4.0, by EEJCC, from
// Wikimedia Commons (https://commons.wikimedia.org/wiki/File%3ADoheny_Memorial_Library_of_USC.jpg), checked 2026-09-30 by
// scripts/college-photo.mjs (license allowlist, no restrictions, not a logo).
// Resized and self-hosted under public/colleges/university-of-southern-california/; credited under the photo.
const photo = {
    "slug": "university-of-southern-california",
    "alt": "Doheny Memorial Library on the USC campus in Los Angeles",
    "src": "/colleges/university-of-southern-california/campus-1600.webp",
    "srcSmall": "/colleges/university-of-southern-california/campus-800.webp",
    "srcMid": "/colleges/university-of-southern-california/campus-1200.webp",
    "width": 1600,
    "height": 900,
    "og": "/colleges/university-of-southern-california/og.jpg",
    "title": "Doheny Memorial Library of USC",
    "author": "EEJCC",
    "license": "CC BY-SA 4.0",
    "licenseUrl": "https://creativecommons.org/licenses/by-sa/4.0",
    "sourceUrl": "https://commons.wikimedia.org/wiki/File%3ADoheny_Memorial_Library_of_USC.jpg",
    "read": "2026-09-30"
};

export default photo;
